import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';

import { clicks, useHandleAddToCart } from '../com.zedock.common.script/common.js';

import '../com.zedock.common.style/Product.css';
import '../com.zedock.common.style/common.css';

function Product() {
    const navigate = useNavigate();
    const location = useLocation();
    const [products, setProducts] = useState([]);
    const [category, setCategory] = useState(location.state?.category ?? "");
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const addToCartFunc = useHandleAddToCart();

    useEffect(() => {
        clicks(location.pathname);
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, []);


    useEffect(() => {
        const loadAndScroll = async () => {
            await getProduct();
            if (page > 0 || category != "")
                window.scrollTo({ top: 650, behavior: 'instant' });
            else
                window.scrollTo({ top: 0, behavior: 'instant' });
        };

        loadAndScroll();
    }, [page, category]);


    useEffect(() => {
        /*
                fetch(`${urls.BASE_URL}/auth/init`, {
                    headers: {
                        "X-XSRF-TOKEN": getCsrfToken()
                    }, credentials: "include"
                });
        
        */
        if (location.state && "category" in location.state) {
            const newCategory = location.state.category;
            if (newCategory !== category) {
                setCategory(newCategory);
                setPage(0);
            }
        }
    }, [location.state?.category]);

    const getProduct = async () => {
        try {
            setLoading(true);
            const response = await
                fetch(`${urls.BASE_URL}` + "/zedock-web/product?page=" + page + "&size=12&category=" + category, {

                    headers: {
                        "X-XSRF-TOKEN": getCsrfToken()
                    },
                    method: "GET",
                    credentials: "include"   // ✅ send JSESSIONID cookie
                });
            const data = await response.json();
            setProducts(data.content);
            setTotalPages(data.totalPages);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="container px-0    ">
            <div className="zd-wrap p-2 p-lg-4">


                <div className="row g-0">

                    {/* breadcrumb */}
                    <nav aria-label="breadcrumb" className="zd-crumb mb-2">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                                <a href="" onClick={(e) => { e.preventDefault(); navigate("/Product") }}>Home</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Product</li>
                        </ol>
                    </nav>
                </div>

                <div className="row  g-2 mb-2">

                    {/* ---------------- hero carousel ---------------- */}
                    <div id="carouselExampleCaptions" className="carousel slide zd-hero position-relative mb-4" data-bs-ride="carousel">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
                        </div>
                        <div className="carousel-inner">
                            <div className="carousel-item active position-relative">
                                <img
                                    src={urls.CDN_URL + 'common/carousel3.webp'}
                                    className="d-block w-100" alt="New arrivals" />
                                <div className="carousel-caption d-none d-md-block">
                                    <span className="eyebrow">New season</span>
                                    <h1>Sculptures & Figurines</h1>
                                    <p>“Hand‑Carved Elegance for Every Space” : This emphasizes artistry and timeless appeal, perfect for elephant, Buddha, and couple figurines.</p>
                                    <button className="zd-cta" onClick={() => navigate("/Product")}>Shop new in</button>
                                </div>
                            </div>
                            <div className="carousel-item position-relative">
                                <img
                                    src={urls.CDN_URL + 'common/carousel1.webp'}
                                    className="d-block w-100" alt="Accessories" />
                                <div className="carousel-caption d-none d-md-block">
                                    <span className="eyebrow">The finishing touch</span>
                                    <h1>Utility & Table Décor</h1>
                                    <p>“Functional Beauty, Crafted in Wood” : Highlights the blend of utility and design — trays, spice boxes, cups, and candle holders.</p>
                                    <button className="zd-cta" onClick={() => navigate("/Product", { state: { category: "Accessories" } })}>Shop accessories</button>
                                </div>
                            </div>
                            <div className="carousel-item position-relative">
                                <img
                                    src={urls.CDN_URL + 'common/carousel2.webp'}
                                    className="d-block w-100" alt="Seasonal offers" />
                                <div className="carousel-caption d-none d-md-block">
                                    <span className="eyebrow">Limited time</span>
                                    <h1>Wall & Festival Décor</h1>
                                    <p>“Celebrate Traditions with Wooden Charm” : Adds a festive, cultural touch for garlands, diya stands, wall shelves, and clocks.</p>
                                    <button className="zd-cta" onClick={() => navigate("/Product")}>View offers</button>
                                </div>
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
                {/* ---------------- category rail ---------------- */}

                <div className="row  g-2 mb-2">

                    <div className="scroll-div">
                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "Wooden Wall Hanging" } })}>
                            <img src={urls.CDN_URL + 'common/01_Wooden_Wall_Hanging.webp'} alt="Wooden Wall Hanging" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">120+ styles</span>
                                <h6>Wooden Wall Hanging</h6>
                            </div>
                        </div>

                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "Wooden Serving Tray" } })}>
                            <img src={urls.CDN_URL + 'common/02_Wooden_Serving_Tray.webp'} alt="Wooden Serving Tray" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">180+ styles</span>
                                <h6>Wooden Serving Tray</h6>
                            </div>
                        </div>
                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "Homes Decoration" } })}>
                            <img src={urls.CDN_URL + 'common/03_Homes_Decoration.webp'} alt="Homes Decoration" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">90+ styles</span>
                                <h6>Homes Decoration</h6>
                            </div>
                        </div>
                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "Charming Elephant Set" } })}>
                            <img src={urls.CDN_URL + 'common/04_Charming_Elephant_Set.webp'} alt="Charming Elephant Set" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">60+ styles</span>
                                <h6>Charming Elephant Set</h6>
                            </div>
                        </div>
                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "Wooden Dhoop Stand" } })}>
                            <img src={urls.CDN_URL + 'common/05_Wooden_Dhoop_Stand.webp'} alt="Wooden Dhoop Stand" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">60+ styles</span>
                                <h6>Wooden Dhoop Stand</h6>
                            </div>
                        </div>

                        {/*---*/}


                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "Floating Diya Stand" } })}>
                            <img src={urls.CDN_URL + 'common/06_Floating_Diya_Stand.webp'} alt="Floating Diya Stand" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">120+ styles</span>
                                <h6>Floating Diya Stand</h6>
                            </div>
                        </div>

                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "Door Decoration" } })}>
                            <img src={urls.CDN_URL + 'common/07_Door_Decoration.webp'} alt="Door Decoration" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">180+ styles</span>
                                <h6>Door Decoration</h6>
                            </div>
                        </div>
                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "Sculpture" } })}>
                            <img src={urls.CDN_URL + 'common/08_Sculpture.webp'} alt="Sculpture" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">90+ styles</span>
                                <h6>Sculpture</h6>
                            </div>
                        </div>
                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "USB LED Night Light" } })}>
                            <img src={urls.CDN_URL + 'common/09_USB_LED_Night_Light.webp'} alt="USB LED Night Light" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">60+ styles</span>
                                <h6>USB LED Night Light</h6>
                            </div>
                        </div>
                        <div className="zd-cat" onClick={() => navigate("/Product", { state: { category: "Metal Flower Vase" } })}>
                            <img src={urls.CDN_URL + 'common/10_Metal_Flower_Vase.webp'} alt="Metal Flower Vase" />
                            <span className="zd-cat-ribbon">Shop now</span>
                            <div className="zd-cat-label">
                                <span className="zd-count">60+ styles</span>
                                <h6>Metal Flower Vase</h6>
                            </div>
                        </div>
                    </div>
                </div>
                {/*---*/}

                <div className="row  g-2 mb-2">

                    <div class="zd-offer-banner">
                        🎉 Special Offer for New Customers!
                        Get 10% OFF on all products.
                        Use Coupon Code: <span>ZDNEW10</span>
                    </div>
                </div>
                {/* ---------------- product grid ---------------- */}

                <div className="zd-section-head">
                    <h3>Trending now</h3>
                    <span>{products.length} items</span>
                </div>
                {loading ? (
                    <div className="zd-loader-wrap text-center py-5">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className='almost-ready'> Almost ready!</div>
                    </div>
                ) : (
                    <div className="row  g-2 mb-2">
                        {products.map((item) => (
                            <div key={item.id} className="col-6 col-lg-3">
                                <div className="zd-product">
                                    <div className="zd-product-imgwrap">
                                        <span className="zd-badge-new">New</span>
                                        <img src={urls.CDN_URL + 'products_thumb/' + item.sku + '.webp'} alt={item.name} onClick={() => navigate("/Specifications", { state: item })} />
                                        <button className="zd-cart-fab" onClick={(e) => addToCartFunc(item.id, 1)} aria-label="Add to cart">
                                            <img src={urls.CDN_URL + "cart.webp"} alt="" height={18} width={18} />
                                        </button>
                                    </div>
                                    <div className="zd-product-body">
                                        <h6>{item.name}</h6>

                                        <span className="zd-price">₹{item.price} </span>
                                        <span className="zd-price-strick">(₹{item.mrp}) </span>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {/* ---------------- pagination ---------------- */}
                <div className="row  g-2 mb-2">

                    <div className="zd-pagination">
                        <button disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
                        <span className="zd-page-info">Page {page + 1} of {totalPages}</span>
                        <button disabled={page === totalPages - 1} onClick={() => setPage(page + 1)}>Next</button>
                    </div>
                </div>


            </div >

        </div >

    );
}

export default Product;
